@if (countries && languages) {
<div
  class="login-form-wrapper"
  [ngClass]="{ 'asm-enabled': asmEnabled }"
>
  <cx-global-message class="login-global-message">
    <div class="global-message-wrapper"></div>
  </cx-global-message>
  <div class="login-form-content">
    @if (err) {
    <div class="login-error alert alert-danger alert-dismissible fade show" role="alert">
      {{ 'login.error' | cxTranslate }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    }
    <form [formGroup]="signinForm" (ngSubmit)="login()" [action]="action" [method]="method" #loginForm>
      @if (!asmEnabled) {
      <div class="form-group login-form-country login-form-businesstype">
        @if (businnesTypes.length > 1) {
        <div
          ngbDropdown
          class="country-selection-container mat-primary mat-form-field"
          [placement]="['bottom', 'top']"
          (openChange)="onOpenDropdown($event)"
        >
          <span class="country-label">{{ 'login.accountType' | cxTranslate }}</span>
          <button
            class="btn-link country-selection-dropdown"
            id="businessTypeSelectorDropdown"
            ngbDropdownToggle
            type="button"
            disableOptionCentering
          >
            <span class="country-selected">{{ getBusineessTypeActiveLabel() }}</span>
            <mat-icon class="material-icons-sharp select-button" [class.rotated]="dropdownIsOpened"
              >expand_more</mat-icon
            >
            <div
              ngbDropdownMenu
              [ngClass]="selectedCountry"
              class="dropdown-menu"
              aria-labelledby="businessTypeSelectorDropdown"
            >
              @for (item of businnesTypes; track item; let countryIndex = $index) {
              <button
                ngbDropdownItem
                [class.selected]="item.code === businessTypeSelected"
                (click)="selectBusinessType(item)"
                type="button"
              >
                @if (item.code === businessTypeSelected) {
                <mat-icon svgIcon="check" [ngClass]="activeBusinessType$ | async" class="selected-icon"></mat-icon>
                }
                {{ item.label }}
              </button>
              }
            </div>
          </button>
        </div>
        }
      </div>
      } @if (!asmEnabled) {
      <div class="form-group login-form-country" [class.no-flags]="!(isCountryFlagIconEnabled$ | async)">
        <div
          ngbDropdown
          class="country-selection-container mat-primary mat-form-field"
          [placement]="['bottom', 'top']"
          (openChange)="countryOnOpenDropdown($event)"
        >
          <span class="country-label">{{ 'login.selectCountry' | cxTranslate }}</span>
          <button
            class="btn-link country-selection-dropdown"
            id="dealerSelectorDropdown"
            ngbDropdownToggle
            (click)="onCountrySelection(countries)"
            type="button"
            disableOptionCentering
            [ngClass]="[activeCountry$ | async, !(isCountryFlagIconEnabled$ | async) ? 'no-flags' : '']"
          >
            @if (isCountryFlagIconEnabled$ | async) {
            <span matPrefix [class.flag-prefix]="countrySelected">
              @if (!countrySelected) {
              <mat-icon matprefix="" class="material-icons-sharp light">language</mat-icon>
              } @if (countrySelected) {
              <span class="flag:{{ countrySelected }}"></span>
              }
            </span>
            }
            <span class="country-selected">{{ selectedCountry }}</span>
            @if (currentCountry !== 'cn') {
            <mat-icon class="material-icons-sharp select-button" [class.rotated]="countryDropdownIsOpened"
              >expand_more</mat-icon
            >
            } @else {
            <mat-icon [ngClass]="activeCountry$ | async" class="mat-select-arrow select-button"></mat-icon>
            }
            <div
              ngbDropdownMenu
              [ngClass]="selectedCountry"
              class="dropdown-menu"
              aria-labelledby="dealerSelectorDropdown"
            >
              @for (item of countries; track item; let countryIndex = $index) {
              <button
                ngbDropdownItem
                [class.selected]="item.isocode === countrySelected"
                (click)="selectCountry(item)"
                type="button"
              >
                @if (item.isocode === countrySelected) {
                <mat-icon svgIcon="check" [ngClass]="activeCountry$ | async" class="selected-icon"></mat-icon>
                } @if (isCountryFlagIconEnabled$ | async) {
                <span class="flag:{{ item.isocode }}"></span>
                }
                {{ item.name }}
              </button>
              }
            </div>
          </button>
        </div>
      </div>
      } @if (!asmEnabled) {
      <div class="form-group login-form-language">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'login.selectLanguage' | cxTranslate }}</mat-label>
          <mat-select
            formControlName="language"
            [(ngModel)]="langSelected"
            (selectionChange)="selectLang($event)"
            disableOptionCentering
            [ngClass]="activeLanguage$ | async"
            [panelClass]="['login-select', activeCountry$ | async, !requestAccountEnabled ? 'no-register' : '']"
          >
            @for (item of language; track item; let langIndex = $index) {
            <mat-option class="js-login-selectLanguange" [id]="langIndex" value="{{ item.isocode }}">{{
              item.name
            }}</mat-option>
            }
          </mat-select>
          <span matPrefix>
            <mat-icon matprefix="" class="material-icons-sharp light">translate</mat-icon>
          </span>
        </mat-form-field>
      </div>
      }
      <div class="form-group login-form-email" [class.autofilled]="autofilled">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'login.emailAdd' | cxTranslate }}</mat-label>
          <input
            matInput
            type="email"
            id="login-form-email"
            class="form-control"
            formControlName="email"
            [placeholder]="
              isEmailFocused ? checkRememberMe(signinForm.controls.email.value, 'login.emailAdd' | cxTranslate) : ''
            "
            (focus)="isEmailFocused = true; onFocus('email')"
            (blur)="isEmailFocused = false"
            #emailAddr
          />
        </mat-form-field>
      </div>
      <div class="form-group login-form-password" [class.login-form-asm-password]="asmEnabled">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'login.password' | cxTranslate }}</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            id="login-form-password"
            class="form-control"
            formControlName="password"
            name="password"
            [placeholder]="
              isPasswordFocused
                ? checkRememberMe(signinForm.controls.password.value, 'login.password' | cxTranslate)
                : ''
            "
            (focus)="isPasswordFocused = true; onFocus('password')"
            (blur)="isPasswordFocused = false"
            #passwordField
          />
          <span matSuffix>
            <mat-icon matSuffix="" class="material-icons-outlined" (click)="hidePassword = !hidePassword">{{
              hidePassword ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </span>
        </mat-form-field>
      </div>
      <div class="form-forgot-mobile">
        <a (click)="goToForgotPassword()" [routerLink]="['/login/forgot-password']">{{
          'login.forgotPassword' | cxTranslate
        }}</a>
      </div>
      <div class="form-group login-form-button">
        <button mat-button class="btn-primary">{{ 'login.login' | cxTranslate }}</button>
      </div>
      <div class="d-flex" [ngClass]="isCountrySnah() ? 'justify-content-end' : 'justify-content-between'">
        <mat-checkbox
          [class.d-none]="isCountrySnah()"
          class="form-show-srp js-login-srpCheckbox"
          [disableRipple]="true"
          formControlName="showSrpToggle"
        >
          {{ 'login.showSrp' | cxTranslate }}
        </mat-checkbox>
        <div class="form-forgot d-none d-md-block">
          <a (click)="goToForgotPassword()" [routerLink]="['/login/forgot-password']">{{
            'login.forgotPassword' | cxTranslate
          }}</a>
        </div>
      </div>
      @if (csrf) {
      <input formControlName="csrf" type="hidden" [name]="csrf.parameterName" />
      }
    </form>
    @if (!asmEnabled && requestAccountEnabled) {
    <div class="form-request">
      <p>
        {{ 'login.noAccount' | cxTranslate }}
        @if (requestAccountUrl) {
        <a
          class="routerLink"
          href="{{ requestAccountUrl }}"
          target="_blank"
          (click)="requestAccount(true, requestAccountUrl)"
          >{{ 'login.requestAccount' | cxTranslate }}</a
        >
        } @if (requestAccountUrl === '') {
        <a [routerLink]="['/login']" (click)="requestAccount(true, requestAccountUrl)">{{
          'login.requestAccount' | cxTranslate
        }}</a>
        }
      </p>
    </div>
    } @if (!!asmEnabled) {
    <div class="form-filler"></div>
    }
  </div>
</div>
}
